module.exports = __webpack_public_path__ + "static/img/ssr-logo.d2a1dc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ssr-logo.png
// module id = nuB1
// module chunks = 1